
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./../assets/base_logo.png";
import "./../Styles/SplashScreen.css";

const SplashScreen = ({ onLoadingComplete }) => {
  const [splashVisible, setSplashVisible] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Show splash for 2.5 seconds, then go straight to home. (The Pluxee
    // info popup used to show here; it now shows on Home itself instead.)
    const timer = setTimeout(() => {
      setSplashVisible(false);
      if (onLoadingComplete) {
        onLoadingComplete();
      }
      navigate("/home");
    }, 2500);

    return () => clearTimeout(timer);
  }, [onLoadingComplete, navigate]);

  return (
    <div className="splash-screen">
      <div className="splash-content">
        <div className="logo-container">
          <img src={logo} alt="Food You'd Cook Logo" className="splash-logo" />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;